import React, {Fragment, useCallback, useRef} from 'react';
import Landmark from '@core/scripts/components/landmark-adapter';
import Icon from '@bonprix/pattern-library/templates/icon';
import {Tooltip, Typography} from '@bonprix/design-system';

export default function AddReviewButton({texts}) {

    const landmarkSent = useRef(false);

    const sendLandmark = useCallback(() => {
        if (!landmarkSent.current) {
            Landmark.sendClickLandmark('adp_reviews_tooltip_no_order');
            landmarkSent.current = true;
        }
    }, []);

    return (
        <>
            <div className="reviews__add-review-tooltip-wrapper">
                <Tooltip zIndex={1100} content={<Typography variant="body1">{texts.ada_reviews_tooltip_content}</Typography>}>
                    <div className="reviews__add-review-tooltip-label" onMouseEnter={sendLandmark}>
                        {texts.ada_reviews_tooltip_title}
                        <Icon className="reviews__add-review-tooltip-label-icon" name="hint" />
                    </div>
                </Tooltip>
            </div>
        </>
    );
}
